import { Transaction } from "./Transaction"
import { TransactionType } from "../shared/Consts";
import { Cols } from "../shared/Consts"
import Utils from "../portlibs/PortUtils";
import GICHolding from "./GICHolding";

export class GICTransaction extends Transaction{
    get payout(){ return this.price*this.quantity*this.yield/100 }
    get principal(){return this.quantity}
    get coupon(){
        if (this.holding?.price?.frequency) return this.principal*this.yield/100*this.holding.price.distributionYield
        else return this.principal*this.yield/100
    }
    
    override clone(){return new GICTransaction(this.holding, this)}
    override get actionName(){
        if (this.type==TransactionType.buy) return this.quantity > 0 ? "Buy" : "Redemption"
        else return super.actionName
    }
    override rawValue(col:string) : string|number {
        switch(col){
        case Cols.maturity:     return Utils.formatDate("yyyy-MM-dd", this.maturity);
        case Cols.yield:        return this.yield;
        default:                return super.rawValue(col)
        }
    }
    override get payload(){
        const ret = super.payload;
        ret.yield = this.yield;
        ret.maturity = Utils.formatDate("yyyy-MM-dd", this.maturity)
        return ret;
    }
    get purchaseTransaction() : GICTransaction|null{
        return (this.holding as GICHolding).purchaseTransaction
    }
    override addActionClass(klass:string[]){
        switch(this.type){
        case TransactionType.adjust:
        case TransactionType.buy:       klass.push(this.quantity>0?"blue":"red"); break;
        case TransactionType.interest:
        case TransactionType.dividend:  klass.push("green"); break;
        }
    }
}